// extracted by mini-css-extract-plugin
module.exports = {"article":"ItemQuantityBox-article-2MkXk","green":"ItemQuantityBox-green-lG9id","itemQtyLabel":"ItemQuantityBox-itemQtyLabel-2tENP","itemQty":"ItemQuantityBox-itemQty-VocVe"};